import type { ReactNode, PointerEvent as ReactPointerEvent } from "react";
import { cn } from "@/lib/utils";

interface ResizableThProps {
  /** Omit to let the column render with no explicit width (fills leftover space). */
  width?: number;
  onResizeStart: (e: ReactPointerEvent) => void;
  className?: string;
  children?: ReactNode;
}

export function ResizableTh({ width, onResizeStart, className, children }: ResizableThProps) {
  return (
    <th
      style={width !== undefined ? { width } : undefined}
      className={cn("relative px-4 py-3 text-left font-medium text-muted-foreground", className)}
    >
      <span className="block truncate select-none">{children}</span>
      <span
        onPointerDown={onResizeStart}
        className="absolute right-0 top-1/2 h-1/2 w-px -translate-y-1/2 cursor-col-resize touch-none select-none bg-border transition-colors hover:bg-primary/60 active:bg-primary/80"
      />
    </th>
  );
}
